import React from 'react';
import SvgIcon from './SvgIcon';

const TimeClock = props => (
    <SvgIcon viewBox="0 0 120 120" {...props}>
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.156394595">
            <g
                id="1---Incidents---List"
                transform="translate(-173.000000, -148.000000)"
                fill="#FFFFFF"
                fillRule="nonzero"
            >
                <g id="Account-Overview" transform="translate(84.000000, 136.000000)">
                    <g id="time-clock" transform="translate(89.000000, 12.000000)">
                        <path
                            d="M110.213407,65.0213407 C107.440197,65.0213407 105.192066,62.7732099 105.192066,60 C105.192066,57.2267901 107.440197,54.9786593 110.213407,54.9786593 L120,54.9786593 C117.518443,25.7041812 94.2958188,2.48155744 65.0213407,0 L65.0213407,9.78659302 C65.0213407,12.5598029 62.7732099,14.8079337 60,14.8079337 C57.2267901,14.8079337 54.9786593,12.5598029 54.9786593,9.78659302 L54.9786593,0 C25.7041812,2.48155744 2.48155744,25.7041812 0,54.9786593 L9.78659302,54.9786593 C12.5598029,54.9786593 14.8079337,57.2267901 14.8079337,60 C14.8079337,62.7732099 12.5598029,65.0213407 9.78659302,65.0213407 L0,65.0213407 C2.48155744,94.2958188 25.7041812,117.518443 54.9786593,120 L54.9786593,110.213407 C54.9786593,107.440197 57.2267901,105.192066 60,105.192066 C62.7732099,105.192066 65.0213407,107.440197 65.0213407,110.213407 L65.0213407,120 C94.2958188,117.518443 117.518443,94.2958188 120,65.0213407 L110.213407,65.0213407 Z M80.0853628,65.0213408 L60,65.0213408 C58.3214736,65.0213408 56.7538267,64.1831269 55.8222445,62.7868441 L35.7368817,32.6587999 C34.1977503,30.3514893 34.8204825,27.2333318 37.1277931,25.6942004 C39.4351038,24.1550689 42.5532612,24.7778011 44.0923927,27.0851117 L62.6864173,54.9786593 L80.0853628,54.9786593 C82.8585727,54.9786593 85.1067035,57.2267901 85.1067035,60 C85.1067035,62.7732099 82.8585727,65.0213408 80.0853628,65.0213408 Z"
                            id="Shape"
                        ></path>
                    </g>
                </g>
            </g>
        </g>
    </SvgIcon>
);

TimeClock.displayName = 'TimeClockIcon';

export default TimeClock;
